export default {"src":"/_next/static/media/awards.a2e373da.svg","height":59,"width":176,"blurWidth":0,"blurHeight":0};